import {
  ReplayRounded,
  SellOutlined,
  VisibilityRounded,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React, { useContext } from "react";
import { lsSave } from "../../../hooks/Method";
import { useNavigate } from "react-router-dom";
import { AppContext } from "App";

const SaleAction = ({ item, handleView }) => {
  const { access } = useContext(AppContext);
  const navigate = useNavigate();

  const handleContinuSale = () => {
    lsSave("procSaleId", item.id);
    navigate("/sell");
  };

  const handleReturn = () => {
    navigate(`/sell_return_form/${item.id}`);
  };

  return (
    <div className="flex border shadow-sm gap-2 rounded-[8px] w-fit">
      <Tooltip title="View Details">
        <IconButton
          onClick={() => handleView(item)}
          size="small"
          color="primary"
          className="p-5"
        >
          <VisibilityRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      {item.type !== 3 &&
        (item.status === 1 ? (
          <Tooltip title="Continue Sale">
            <IconButton
              onClick={handleContinuSale}
              size="small"
              color="primary"
              className="p-5"
            >
              <SellOutlined className="fs-18 m-2" />
            </IconButton>
          </Tooltip>
        ) : (
          access?.salesHistory?.returnSale && (
            <Tooltip title={<span className="text-red-500">Return Sale</span>}>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleReturn();
                }}
                size="small"
                color="error"
                className="p-5"
              >
                <ReplayRounded className="fs-18 m-2" />
              </IconButton>
            </Tooltip>
          )
        ))}
    </div>
  );
};

export default SaleAction;
